import { Component, input, output } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { ticketAttachmentKind } from '../../domain/ticket-attachment-types';

export interface TicketSelectedUploadLabels {
  readonly previewAttachment: string;
  readonly removeFile: string;
}

export interface TicketSelectedAttachmentEvent {
  readonly file: File;
  readonly trigger?: HTMLElement;
}

@Component({
  selector: 'app-ticket-selected-uploads',
  standalone: true,
  imports: [NgIcon],
  templateUrl: './ticket-selected-uploads.component.html',
  styleUrl: './ticket-selected-uploads.component.scss',
})
export class TicketSelectedUploadsComponent {
  readonly attachments = input<readonly File[]>([]);
  readonly audio = input<File | null>(null);
  readonly audioRecorded = input(false);
  readonly video = input<File | null>(null);
  readonly previewUrl = input.required<(file: File) => string | null>();
  readonly labels = input<TicketSelectedUploadLabels>({
    previewAttachment: 'Preview attachment',
    removeFile: 'Remove',
  });
  readonly attachmentRemoved = output<number>();
  readonly audioRemoved = output<void>();
  readonly videoRemoved = output<void>();
  readonly attachmentOpened = output<TicketSelectedAttachmentEvent>();
  readonly imageFailed = output<File>();

  formatFileSize(file: File): string {
    if (file.size < 1024 * 1024) {
      return `${Math.max(1, Math.round(file.size / 1024))} KB`;
    }
    return `${(file.size / (1024 * 1024)).toFixed(1)} MB`;
  }
  isSpreadsheet(file: File): boolean {
    return ticketAttachmentKind(file.name, file.type) === 'spreadsheet';
  }
  openAttachment(file: File, event: Event): void {
    this.attachmentOpened.emit({
      file,
      trigger:
        event.currentTarget instanceof HTMLElement
          ? event.currentTarget
          : undefined,
    });
  }
}
